import axios from 'axios'
import {
  FETCH_EXTERNAL_USER_FLAGS_LOGS_URL,
  FETCH_LOGIN_EVENTS_LOGS_URL,
  FETCH_REQUISITE_HISTORY_LOGS_URL,
  FETCH_RISK_SCORE_LOGS_URL,
  FETCH_USER_EVENTS_LOGS_URL,
} from './consts'
import {
  IFetchExternalUserFlagsParams,
  IFetchLoginEventsParams,
  IFetchLoginEventsResponse,
  IFetchRequisiteHistoryParams,
  IFetchRequisiteHistoryResponse,
  IFetchRiskScoreLogsParams,
  IFetchRiskScoreLogsResponse,
  IFetchUserEventsParams,
  IFetchUserEventsResponse,
} from './logs.types'

export const fetchLoginEventsLogs = (params: IFetchLoginEventsParams) => {
  return axios.get<IFetchLoginEventsResponse>(`${FETCH_LOGIN_EVENTS_LOGS_URL}`, {
    params: {
      ...params,
      perPage: 20,
    },
  })
}

export const fetchUserEventsLogs = (params: IFetchUserEventsParams) => {
  return axios.get<IFetchUserEventsResponse>(`${FETCH_USER_EVENTS_LOGS_URL}`, {
    params: {
      ...params,
      perPage: 20,
    },
  })
}

export const fetchRequisitesHistoryLogs = (params: IFetchRequisiteHistoryParams) => {
  const newParams = Object.fromEntries(Object.entries(params).filter(([_, v]) => !!v))
  if (params.xlsx) {
    return axios.get(`${FETCH_REQUISITE_HISTORY_LOGS_URL}`, {
      params: {
        ...newParams,
        perPage: 100,
      },
      responseType: 'blob',
    })
  }

  return axios.get<IFetchRequisiteHistoryResponse>(`${FETCH_REQUISITE_HISTORY_LOGS_URL}`, {
    params: {
      ...newParams,
      perPage: 100,
    },
  })
}

export const fetchRiskScoreLogs = (params: IFetchRiskScoreLogsParams) => {
  const newParams = Object.fromEntries(Object.entries(params).filter(([_, v]) => v !== null && v !== undefined))
  return axios.get<IFetchRiskScoreLogsResponse>(FETCH_RISK_SCORE_LOGS_URL, { params: newParams })
}

export const fetchExternalUserFlagsLogs = (params: IFetchExternalUserFlagsParams) => {
  const newParams = Object.fromEntries(Object.entries(params).filter(([_, v]) => !!v))
  
  return axios.get(`${FETCH_EXTERNAL_USER_FLAGS_LOGS_URL}`, {
    params: newParams,
    responseType: 'blob',
    // Принимаем любые статусы ответа, чтобы обработать ошибки вручную
    validateStatus: function (status) {
      return true // Всегда возвращаем true, чтобы обработать ошибки вручную
    }
  }).catch(error => {
    // Если ошибка содержит response с данными, возвращаем их для обработки
    if (error.response && error.response.data) {
      return error.response
    }
    throw error // Иначе пробрасываем ошибку дальше
  })
}
